import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../Context/Context";
import Location from "../Reusables/Location/Location";
import Button from "../Reusables/Button/Button";
import TimeRangePopup from "../Modal/TimeRangePopup/TimeRangePopup";
import AdditionalDashboardModal from "../Modal/AdditionalDashboardModal";
import logo from "../../assets/images/logo.png";
import Timer from "../../assets/icons/timer.png";
import Arrow from "../../assets/icons/arrow.png";
import heatMapIcon from "../../assets/icons/fire.png";
import "../../assets/css/Navbar/Navbar.css";
import { setTimeRangeType } from "../../store/plantSlice";
import { useDispatch, useSelector } from "react-redux";

const Navbar = () => {
  const { plantCode } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    setOpenTimeMachineRangePopup,
    timeRangePopup,
    setTimeRangePopup,
    additionalDashboardModalIsOpen,
    setAdditionalDashboardModalIsOpen,
    setSiteSelectionModal,
    plantConfig
  } = useContext(AppContext);

  const { navQualityHeatmapIsEnabled } = useSelector(
    (state) => state.navHeatmap
  );

  const { timeMachineModeIsEnabled } = useSelector(
    (state) => state.oldTimeMachine
  );

  const { timeMachineV2ModeIsEnabled } = useSelector(
    (state) => state.newTimeMachine
  );

  const openTimeMachineRange = () => {
    setTimeRangePopup(!timeRangePopup);
    dispatch(setTimeRangeType("timeMachine"));
  };

  const openNavQualityHeatmapRange = () => {
    setTimeRangePopup(!timeRangePopup);
    dispatch(setTimeRangeType("navHeatmap"));
  };

  const openNewTimeMachine = () => {
    if (!timeMachineV2ModeIsEnabled) {
      navigate("new-time-machine");
      return;
    }
    setOpenTimeMachineRangePopup(true);
  };

  const openHeatMapRange = () => {
    setTimeRangePopup(!timeRangePopup);
    dispatch(setTimeRangeType("heatmap"));
  };

  const openAdditionalDashboard = () => {
    setAdditionalDashboardModalIsOpen(true);
    document.body.classList.add("prevent-scroll");
  };

  const isNavAndTimeMachineEnabled = (feature) => {
    if (plantConfig?.[feature]?.isEnabled) return true;
    return false;
  };

  const renderTimeMachineOrHeatmap = () => {
    if (!timeMachineModeIsEnabled) {
      return (
        <>
          <Button
            btnClass={timeMachineModeIsEnabled ? "time-machine-selected" : ""}
            icon={Timer}
            onClick={openTimeMachineRange}
            placeholder="Time Machine"
          ></Button>

          {isNavAndTimeMachineEnabled("timeMachine") ? (
            <span>
              <Button
                btnClass={
                  timeMachineV2ModeIsEnabled ? "new-time-machine-selected" : ""
                }
                icon={Timer}
                onClick={openNewTimeMachine}
                placeholder="New Time Machine"
              />
            </span>
          ) : null}

          {isNavAndTimeMachineEnabled("navHeatmap") ? (
            <span>
              <Button
                btnClass={navQualityHeatmapIsEnabled ? "heat-map-selected" : ""}
                imgClass="heatmap-icon"
                icon={heatMapIcon}
                onClick={openNavQualityHeatmapRange}
                placeholder="Nav Quality Heatmap"
              ></Button>
            </span>
          ) : null}
        </>
      );
    } else {
      if (timeMachineModeIsEnabled) {
        return (
          <Button
            btnClass={timeMachineModeIsEnabled ? "time-machine-selected" : ""}
            icon={Timer}
            onClick={openTimeMachineRange}
            placeholder="Time Machine"
          ></Button>
        );
      } else if (isNavAndTimeMachineEnabled("navHeatmap")) {
        if (navQualityHeatmapIsEnabled) {
          return (
            <Button
              btnClass={navQualityHeatmapIsEnabled ? "heat-map-selected" : ""}
              imgClass="heatmap-icon"
              icon={heatMapIcon}
              onClick={openNavQualityHeatmapRange}
              placeholder="Nav Quality Heatmap"
            ></Button>
          );
        }
      }
    }
  };

  return (
    <>
      <div className="navbar-container">
        <div className="left-section">
          <div
            className="logo"
            onClick={() =>
              plantCode ? navigate(`/${plantCode}`) : navigate("/")
            }
          >
            <img src={logo} alt="Niagara LGV One" />
          </div>
          <div className="location">
            <Location onClick={() => setSiteSelectionModal(true)} />
          </div>
        </div>
        <div className="right-section">
          {renderTimeMachineOrHeatmap()}
          {timeMachineModeIsEnabled ? null : (
            <>
              <Button
                imgClass="heatmap-icon"
                icon={heatMapIcon}
                onClick={openHeatMapRange}
                placeholder="Heatmap"
              />
              <Button
                onClick={() => openAdditionalDashboard()}
                btnClass="reverse-content"
                imgClass="reverse-content-img"
                placeholder="Additional Dashboards"
                icon={Arrow}
              />
            </>
          )}
        </div>
        <TimeRangePopup />
      </div>
      {additionalDashboardModalIsOpen && <AdditionalDashboardModal />}
    </>
  );
};

export default Navbar;
